/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Code2Inputs */

const en_reference_field_code2 = /** @type {(inputs: Reference_Field_Code2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2-letter code`)
};

/**
* | output |
* | --- |
* | "2-letter code" |
*
* @param {Reference_Field_Code2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_code2 = /** @type {((inputs?: Reference_Field_Code2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Code2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_code2(inputs)
});